import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, ErrorHandler, Inject } from '@angular/core';
import { ILogger } from './models/ILogger';
import { LOGGER_TOKEN } from './InjectionTokens';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
    static readonly ignoreList: {
        url?: string;
        status?: number;
        hostname?: string; // ignores any errors from this hostname
    }[] = [
        {
            url: 'http://maintenancemanager.seliselocal.com/api/tenants?SiteId=08C4A8E1-C4D5-4839-BA1F-FB09A41EE958'
        },
        {
            url: 'https://maintenancemanager.seliselocal.com/api/tenants?SiteId=08C4A8E1-C4D5-4839-BA1F-FB09A41EE958'
        },
        {
            hostname: 'hooks.slack.com'
        }
    ] as const;

    constructor(@Inject(LOGGER_TOKEN) private readonly logger: ILogger) {}

    handleError(error: Error | HttpErrorResponse): void {
        if (error instanceof HttpErrorResponse && CustomErrorHandler.ignoreError(error) === true) {
            return;
        }
        this.logger.error(error);
    }

    /** Ignores specific errors */
    public static ignoreError(error: HttpErrorResponse): boolean {
        // if no error was sent, we can ignore.
        if (!error) {
            return true;
        }
        for (const item of CustomErrorHandler.ignoreList) {
            if (item.status && error.status) {
                if (error.status === item.status) {
                    return true;
                }
            }

            if (item.url && error.url) {
                if (error.url === item.url) {
                    return true;
                }
            }

            if (item.hostname && error.url) {
                const url = new URL(error.url);
                if (url.hostname === item.hostname) {
                    return true;
                }
            }
        }

        return false;
    }
}
